import PageContent from "../../components/page-content";

export default function Page() {
    return (
        <>
            <PageContent />
        </>
    )
}